import React from 'react';
import PortfolioSectionContainer from '../components/portfolio-page-components/PortfolioSectionContainer';

export default function Portfolio() {
    return (
        <div className="main-section">
            <PortfolioSectionContainer/>
        </div>
    )
}